import styled from "styled-components";

const ButtonStyled = styled.button`
  height: 4.5vh;
  max-height: 50px;
  width: 100%;
  min-height: 40px;
  padding: 7px 10px;
  border-radius: 50px;

  ${({ theme, variant, marginTop }) =>
    variant === "secondary"
      ? `
        background-color: transparent;
        border: none;
        color: ${theme.colors.blue};
        font-size: 0.875rem;
        font-family: ${theme.font.family.primary};
        margin-top: ${marginTop || "1.25rem"};
        height: auto;
        max-height: none;
        width: auto;
        min-height: auto;
        padding: 0;
        border-radius: 0;
        text-decoration: underline;
        display: inline-block;

        &:hover {
          filter: none;
        }
      `
      : `
        background-color: ${theme.colors.lightYellow};
        border: 1px solid ${theme.colors.input.border};
        color: ${theme.colors.black};
        font: ${`${theme.font.size.xSmallCalc} ${theme.font.family.bold}`};
         margin-top: ${marginTop || "30px"};

        &:hover {
          filter: brightness(0.85);
        }
      `}
  &:disabled {
    background-color: #cbcbcb;
    color: black;
    cursor: not-allowed;
    filter: none;
    pointer-events: none;
  }
`;

export default ButtonStyled;
